// types
import type { ISubModuleConfig } from '~/features/supporters/submodule'

export default function createSupportersRoutes(config: ISubModuleConfig) {
  return [
    {
      name: config.submodulePermissions.PERMISSION,
      path: config.submodulePermissions.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.CREATE.PERMISSION,
      path: config.submodulePermissions.CREATE.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersFormPage.vue'),
      meta: { layout: 'base', middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.CREATE.ORGANIZATION.PERMISSION,
      path: config.submodulePermissions.CREATE.ORGANIZATION.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersOrganizationFormPage.vue'),
      meta: { layout: 'base', middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.EDIT.PERMISSION,
      path: config.submodulePermissions.EDIT.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersFormPage.vue'),
      meta: { layout: 'base', middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.EDIT.ORGANIZATION.PERMISSION,
      path: config.submodulePermissions.EDIT.ORGANIZATION.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersOrganizationFormPage.vue'),
      meta: { layout: 'base', middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.REPORT.PERMISSION,
      path: config.submodulePermissions.REPORT.ROUTE,
      component: () =>
        import('~/pages/admin/reports/supporters/ui/SupportersReportPage.vue'),
      meta: { middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
    {
      name: config.submodulePermissions.MERGE_LIST.PERMISSION,
      path: config.submodulePermissions.MERGE_LIST.ROUTE,
      component: () =>
        import('~/pages/projects/ui/ProjectWorkspaceSupportersMergeListPage.vue'),
      meta: { middleware: ['auth'] },
      props: config,
    },
    {
      name: config.submodulePermissions.REPORT.TEMPLATES.PERMISSION,
      path: config.submodulePermissions.REPORT.TEMPLATES.ROUTE,
      component: () => import('~/pages/admin/reports/supporters/ui/TemplatesReportPage.vue'),
      meta: { layout: 'base-list', middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
    {
      name: config.submodulePermissions.REPORT.TEMPLATES.CREATE.PERMISSION,
      path: config.submodulePermissions.REPORT.TEMPLATES.CREATE.ROUTE,
      component: () => import('~/pages/admin/reports/supporters/ui/FormTemplatePage.vue'),
      meta: { middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
    {
      name: config.submodulePermissions.REPORT.TEMPLATES.EDIT.PERMISSION,
      path: config.submodulePermissions.REPORT.TEMPLATES.EDIT.ROUTE,
      component: () => import('~/pages/admin/reports/supporters/ui/FormTemplatePage.vue'),
      meta: { middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
    {
      name: config.submodulePermissions.REPORT.SEND_MESSAGE.PERMISSION,
      path: config.submodulePermissions.REPORT.SEND_MESSAGE.ROUTE,
      component: () => import('~/pages/admin/reports/supporters/ui/SendMessagePage.vue'),
      meta: { middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
    {
      name: config.submodulePermissions.REPORT.SHARE_SUPPORTERS.PERMISSION,
      path: config.submodulePermissions.REPORT.SHARE_SUPPORTERS.ROUTE,
      component: () => import('~/pages/projects/ui/ProjectWorkspaceSupportersSharePage.vue'),
      meta: { middleware: ['auth'] },
      props: { isGlobal: false, ...config },
    },
  ]
}
